import React from 'react'
import { StackView } from '@planningcenter/tapestry-react'
import { Code, List, PageHeading, Text } from '../../../shared/typography'

export default function page() {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>
        Specifying a <Code backgroundColor="transparent">User-Agent</Code>{' '}
        Header
      </PageHeading>

      <Text>
        All API requests must include a <Code>User-Agent</Code> header. We
        recommend using a value that uniquely identifies your
        application&mdash;typically your application&apos;s name plus a link to
        your application or your email address. For example:
      </Text>

      <List>
        <List.Item>
          <Code>
            My Planning Center App (https://pcapp.example.com/contact)
          </Code>
        </List.Item>
        <List.Item>
          <Code>PCO Demo (me@pcodemo.example.com)</Code>
        </List.Item>
      </List>

      <Text>
        <b>Note:</b> If you don&apos;t supply a <Code>User-Agent</Code> header
        that meets these requirements, your requests may result in a{' '}
        <Code>403 Forbidden</Code> response.
      </Text>
    </StackView>
  )
}
